module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAUCAYAAAC9BQwsAAAAAXNSR0IArs4c6QAAANtJREFUOE/tkjFSAkEURF9b5Q0YIy7hBYwMJJAqEyIzSdEQDTCQAEw11czIxCoJMDDiAlyCaIcz+Cl2Z3VZd6CKeCf83a/+dNcXkWe4u7Uk/KjKoqqh0RjAwUOm/dyL5bDs+wcabgzqbxrtUfjb4mwDNNwTqFf9e3sW/jrXfkHDvYCuYpmzub0K302zGxyCewN1tkO5au/gL2W4G9DxH2QGnIKaYcsC+AYVYtk80qr7BJ0HcCJ8e2eraRKOpsBZMH+JpFWDoYG6nKyIyMntfzkfwEkoeSaSi/LJrQD0WFmcVmvIUwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon-up.png
// module id = 35s2
// module chunks = 1